if (!customElements.get('gma-product-purchase')) {
  customElements.define(
    'gma-product-purchase',
    class GmaProductPurchase extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.anchor =
          document.getElementById(`gma-purchase-slot-${this.sectionId}`) || this.parentElement;
        this.mobileMediaQuery = window.matchMedia('(max-width: 749px)');

        this.updateLayout = this.updateLayout.bind(this);
        this.mobileMediaQuery.addEventListener('change', this.updateLayout);
        this.updateLayout();
      }

      disconnectedCallback() {
        this.mobileMediaQuery?.removeEventListener('change', this.updateLayout);
        this.classList.remove('is-sticky');
        this.anchor?.classList.remove('gma-purchase-slot--relocated');

        if (this.anchor && this.parentElement === document.body) {
          this.anchor.appendChild(this);
        }
      }

      updateLayout() {
        if (!this.anchor) return;

        if (this.mobileMediaQuery.matches) {
          this.anchor.classList.add('gma-purchase-slot--relocated');
          if (this.parentElement !== document.body) {
            document.body.appendChild(this);
          }
          this.classList.add('is-sticky');
        } else {
          this.restoreToProductInfo();
        }

        window?.Shopify?.PaymentButton?.init();
      }

      restoreToProductInfo() {
        this.classList.remove('is-sticky');
        this.anchor.classList.remove('gma-purchase-slot--relocated');

        if (this.parentElement !== this.anchor) {
          this.anchor.appendChild(this);
        }
      }
    }
  );
}
